<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        :persistent="loading"
    >
        <v-card>
            <v-form
                ref="form"
                :disabled="loading"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Add New Entry
                </v-card-title>
                <v-card-text style="height: 70vh; overflow-x: hidden; overflow-y: scroll;">
                    <v-text-field
                        v-if="data"
                        v-model="tempData.MSU_CODE"
                        :label="data.type === 'SINGLE' ? 'MSU Code' : 'MSU Group ID'"
                        disabled
                    />
                    <v-text-field
                        v-if="data"
                        v-model="tempData.NAME"
                        :label="`${data.type === 'SINGLE' ? 'Hospital/Clinic Name' : 'Group Name' }`"
                        disabled
                    />
                    <v-text-field
                        v-model="tempData.PREFIX"
                        label="Prefix"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.FNAME"
                        label="First Name"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.SNAME"
                        label="Last Name"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.SUFFIX"
                        label="Suffix"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.DESIGNATION"
                        label="Designation"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.ACU_CONTACT_PERSON"
                        label="ACU Contact Person"
                        autocomplete="nope"
                    />
                    <v-text-field
                        v-model="tempData.ACU_CLINIC_TELNO"
                        label="ACU Contact No"
                        autocomplete="nope"
                    />
                    <v-textarea
                        v-model="tempData.ACU_SCHEDULE"
                        label="ACU Schedule"
                        autocomplete="nope"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        width="120"
                        :disabled="loading"
                        @click="showDialog = false"
                    >
                        <v-icon>{{ mdiClose }}</v-icon>
                        close
                    </v-btn>
                    <v-btn
                        color="teal darken-1"
                        width="120"
                        style="color: white;"
                        :loading="loading"
                        type="submit"
                    >
                        <v-icon>{{ mdiCheck }}</v-icon>
                        add
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiClose,
    mdiCheck
} from '@mdi/js'

export default {
    props: ['show', 'data', 'notif'],
    data: ()=>({
        mdiClose,
        mdiCheck,
        loading: false,
        tempData: {
            NAME: null,
            MSU_CODE: null,
            PREFIX: null,
            FNAME: null,
            SNAME: null,
            SUFFIX: null,
            DESIGNATION: null,
            ACU_SCHEDULE: null,
            ACU_CONTACT_PERSON: null,
            ACU_CLINIC_TELNO: null
        }
    }),
    computed: {
        ...mapGetters(['addProviderAcuInfoData']),
        showDialog: {
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.resetForm()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        addProviderAcuInfoData(newVal) {
            if (newVal) {
                if (newVal.status === 201) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New record has been added.'
                    this.notif.show = true
                    this.viewProviderAcuInfo({ MSU_C: this.data.type === 'SINGLE' ? this.data.hosp_msu_code : this.data.group_id })
                    this.showDialog = false
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        },
        data: {
            handler(newVal) {
                if (newVal) {
                    this.initData()
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(['addProviderAcuInfo', 'viewProviderAcuInfo']),
        initData() {
            this.tempData = {
                NAME: null,
                MSU_CODE: null,
                PREFIX: null,
                FNAME: null,
                SNAME: null,
                SUFFIX: null,
                DESIGNATION: null,
                ACU_CONTACT_PERSON: null,
                ACU_SCHEDULE: null,
                ACU_CLINIC_TELNO: null
            }
            let newData = structuredClone(this.data)
            this.tempData.MSU_CODE = newData.type === 'SINGLE' ? newData.hosp_msu_code : newData.group_id
            this.tempData.NAME = newData.hosp_name
        },
        resetForm() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
                this.initData()
            }
        },
        submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                this.loading = true
                this.addProviderAcuInfo({ ...this.tempData, MSU_C: this.data.type === 'SINGLE' ? this.data.hosp_msu_code : this.data.group_id })
            }
        }
    }
}
</script>
